import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20soft%20artistic%20abstract%20background%20with%20gentle%20rose%20and%20cream%20tones%2C%20flowing%20organic%20shapes%2C%20feminine%20aesthetic%2C%20soft%20gradients%2C%20dreamy%20atmosphere%2C%20minimalist%20elegant%20design%2C%20warm%20lighting%2C%20subtle%20texture%2C%20romantic%20mood%2C%20modern%20art%20style%2C%20no%20text%2C%20clean%20composition%2C%20gentle%20watercolor%20effect&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="她之间 - 女女情感故事"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          她之间
        </h1>
        <p className="text-sm md:text-lg text-white/90 max-w-2xl leading-relaxed mb-8 md:mb-10">
          探索女性与女性之间真实、细腻的情感世界。<br className="hidden sm:block" />
          在这里，每一个故事都值得被倾听，每一份情感都值得被珍视。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/qinggan-gushi"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            阅读故事
          </Link>
          <Link
            to="/about"
            className="px-6 py-2.5 bg-white/20 text-white border border-white/40 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}